"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@emotion/core");
var isolateCss_1 = require("./isolateCss");
// Function and `class` components will be functions, whereas
// HTML elements like `div` will be strings.
// TODO: Enumerate what possible "types" can be passed in.
var isComponent = function (type) {
    return typeof type === 'function';
};
var isFragment = function (type) {
    return typeof type === 'symbol';
};
var svgNodes = new Set([
    'path',
    'rect',
    'ellipse',
    'circle',
    'g',
    'defs',
    'clipPath',
    'linearGradient',
    'stop',
    'animate',
]);
var isSvgNode = function (type) {
    return svgNodes.has(type);
};
/**
 * What I actually want to type this as
 *   const isolateComponent = (
 *     type: Parameters<typeof createElement>[0],
 *     props: Parameters<typeof createElement>[1] & PropsWithCSS,
 *     ...children: React.ReactNode[]
 *   ) => {
 * But alas, the flow typing for this is generated funky.
 * Refactor later when completely off flow.
 *
 * This is typed to return "any" because `DetaileDReactHTMLElement` doesn't
 * have an appropriate equivalent in our Flow React definition file
 */
var isolateComponent = function (type, props) {
    var _a;
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    if (!type) {
        return core_1.jsx.apply(void 0, __spread([type, props], children));
    }
    // Don't add `stylesResetAttribute` to components since
    // they won't accept `stylesResetAttribute` as a prop.
    // Also don't add to SVG subnodes since resetting them
    // can unset some of their attributes.
    // Only add it to HTML elements.
    if (!isComponent(type) && !isFragment(type) && !isSvgNode(type)) {
        props = __assign(__assign({}, props), (_a = {}, _a[isolateCss_1.stylesResetAttribute] = true, _a));
    }
    // If there's a `css` prop then `isolateCss` it to
    // ensure its specificity is high enough to overtake
    // the reset styles.
    if (props && props.css) {
        props.css = isolateCss_1.isolateCss(props.css);
    }
    return core_1.jsx.apply(void 0, __spread([type, props], children));
};
exports.default = isolateComponent;
